const layout = {
    labelCol: {
        span: 8,
    },
    wrapperCol: {
        span: 16,
    }
}

const tailLayout = {
    wrapperCol: {
        offset: 8,
        span: 16,
    }
}

export { layout, tailLayout }